export const currencyActionsTypes = {
    SET_CURRENCIES: "SET_CURRENCIES",
    SET_CURRENCY_SELECTED: "SET_CURRENCY_SELECTED"
};